import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const pTagStyle = {
    margin: '0',
    textAlign: 'center'
}

function CircularProgressWithOutLabel(props) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
            </Box>
        </Box>
    );
}

function CircularProgressWithLabel(props) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary">
                    <div style={{display:'flex', flexDirection:'column'}}>
                        <p style={pTagStyle}>{`${Math.round(props.value)}%`}</p>
                        <p style={pTagStyle}>Completed</p>
                    </div>
                </Typography>
            </Box>
        </Box>
    );
}

CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     * @default 0
     */
    value: PropTypes.number.isRequired,
};

export function CircularProgressBarWithoutLabel() {
    return (
        <div>
            <CircularProgressWithOutLabel value={100} />
        </div>
    )
}

export function CircularProgressBarWithLabel({ progress }) {
    return (
        <div>
            <CircularProgressWithLabel value={progress} />
        </div>
    )
}